import { css } from '@/styled-system/css';

/**
 * Shared SRP/HDP gutters inside the persistent search shell.
 *
 * Below `lg` (768px), the search content is single-column and owns its own
 * 16px left/right inset. At `lg` and up, `searchLayout` owns the shared
 * outer inset and map/content gap; the content panel aligns flush with the
 * body/media surfaces.
 */
export const searchContentChromeGutter = css({
  paddingInline: 'default',
  lg: {
    paddingLeft: 'zero',
    paddingRight: 'zero',
  },
});

export const searchContentBodyGutter = css({
  paddingInline: 'default',
  lg: {
    paddingLeft: 'zero',
    paddingRight: 'zero',
  },
});
